import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { id: "about" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bigTitle" }, "诊断揭晓"),
  /*#__PURE__*/_createElementVNode("h1", null, "中国变应性鼻炎诊断和治疗指南（2022）"),
  /*#__PURE__*/_createElementVNode("p", null, " AR 的诊断应根据患者典型的过敏病史、临床表现以及与其一致的过敏原检测结果而作出 结合患者主诉、体征、检查及RQLQ量表评分，患者诊断为： "),
  /*#__PURE__*/_createElementVNode("div", { class: "detail" }, [
    /*#__PURE__*/_createTextVNode(" 变应性鼻炎，过敏性结膜炎，喉咽返"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("流，感音神经性耳聋"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 疾病严重程度：重度"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("常年性变应性鼻炎 ")
  ])
], -1)
const _hoisted_2 = { class: "zhentan" }
const _hoisted_3 = { class: "ip" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_image, {
        width: "2.44rem",
        height: "3.5333rem",
        "vertical-align": "left",
        src: require('../assets/ok.png')
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_van_image, {
        class: "footBtn",
        onClick: $options.nexStept,
        width: "5.64rem",
        height: "1.3333rem",
        src: require('../assets/button.png')
      }, null, 8, ["onClick", "src"]),
      _createVNode(_component_van_image, {
        class: "finger",
        width: "1.28rem",
        height: "1.28rem",
        src: require('../assets/dong.gif')
      }, null, 8, ["src"])
    ]),
    _hoisted_4
  ], 64))
}